import React from 'react';
import PropTypes from 'prop-types';

export const StepShape = ({ width, height, ...props }) => (
  <svg
    data-icon='step-shape'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M0.601562 0L12.4783 22.1048C13.7972 24.5596 13.7437 27.5237 12.3372 29.9293L0.601562 50V0Z'
    />
  </svg>
);

StepShape.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

StepShape.defaultProps = {
  width: 24,
  height: 24,
};
